import { ChangeYMCAForm } from '../../forms/change_ymca_form';

export default class View {
	constructor() {
        // stop if wrong page!
        if (!document.querySelector('.change-location-container')) {
          return;
        }
        let container = document.querySelector('.facility-container');
        let form = document.querySelector('.facility-form');
        new ChangeYMCAForm(form, container, this);
    }
}
